
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Banner de urgência */}
      <div className="bg-red-600 text-white py-3 overflow-hidden relative">
        <div className="flex w-max flex-none animate-marquee whitespace-nowrap">
          <div className="flex w-max flex-none shrink-0 whitespace-nowrap">
            <span className="text-sm md:text-base font-bold mx-8">🔥 OFERTA LIMITADA!</span>
            <span className="text-sm md:text-base font-bold mx-8">⚡ O DESCONTO DO PLANO PREMIUM TERMINA EM BREVE!</span>
            <span className="text-sm md:text-base font-bold mx-8">🔥 OFERTA LIMITADA!</span>
            <span className="text-sm md:text-base font-bold mx-8">⚡ O DESCONTO DO PLANO PREMIUM TERMINA EM BREVE!</span>
          </div>
          <div className="flex w-max flex-none shrink-0 whitespace-nowrap" aria-hidden="true">
            <span className="text-sm md:text-base font-bold mx-8">🔥 OFERTA LIMITADA!</span>
            <span className="text-sm md:text-base font-bold mx-8">⚡ O DESCONTO DO PLANO PREMIUM TERMINA EM BREVE!</span>
            <span className="text-sm md:text-base font-bold mx-8">🔥 OFERTA LIMITADA!</span>
            <span className="text-sm md:text-base font-bold mx-8">⚡ O DESCONTO DO PLANO PREMIUM TERMINA EM BREVE!</span>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className={`fixed w-full top-0 z-40 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg mt-0' : 'bg-transparent mt-12'
      }`}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <div className="bg-teal-600 rounded-lg p-2">
                <i className="ri-calculator-line text-xl text-white"></i>
              </div>
              <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                CalculaDP
              </span>
            </div>

            <div className="hidden md:flex items-center gap-6">
              <a href="#recursos" className={`hover:text-white transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
                Recursos
              </a>
              <a href="#precos" className={`hover:text-white transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
                Preços
              </a>
              <a href="#depoimentos" className={`hover:text-white transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
                Depoimentos
              </a>
              <a 
                href="https://calculadp.tiagonogueira.com.br/ponto" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-teal-600 hover:bg-white hover:text-teal-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap"
              >
                Acessar Sistema
              </a>
            </div>

            {/* Menu mobile */}
            <div className="md:hidden">
              <a 
                href="https://calculadp.tiagonogueira.com.br/ponto" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-teal-600 hover:bg-white hover:text-teal-600 text-white px-4 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap"
              >
                Acessar
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
